<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Menedżer stron'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-page-details-view *ngIf="!modify "  [page]="page" (modifyClicked)="modify = true" ></app-page-details-view>
    <app-add-page *ngIf="modify" [pageObject]="pageObject" (closeModification)="modify = false; loadPage()" ></app-add-page>
  </mat-tab>
</mat-tab-group>
